import { Component } from '@angular/core';
import { IconBase } from 'src/app/icons/icon.base';
import { IconConfig } from 'src/app/icons/icon.config';

@Component({
  selector: 'fit-text-quote2-icon',
  templateUrl: './text-quote2.component.html'
})
export class TextQuote2Component extends IconBase {

  constructor(config?: IconConfig) {
    super(config);
  }
}
